import { mastheadTopNavConstant } from "@components/Header/constant";
import type { NavigationA } from "@components/Header/types";

/**
 * Used in navigation
 * To get the masthead links
 */

export const useGetMastheadTopLinks = (headerData?: NavigationA) => {
  const mastheadLinks =
    headerData?.filter((x) => {
      return x.section?.key.includes("masthead-top") && x;
    }) || mastheadTopNavConstant;

  return mastheadLinks;
};
